import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

interface LinesSoufflingState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    prefereds: any;
    relatedSouffingList: any[];
    schema: any;
    meta: any;

    targetForDelete: any[];
    equipments: any[];
    type: any;
    equipment: any;
}

const state: LinesSoufflingState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    prefereds: [],
    relatedSouffingList: [],

    targetForDelete: [],
    equipments: [],
    schema: {},
    meta: {},
    type: null,
    equipment: null,
};

const initState: any = cloneDeep(state);

const LINES_SOUFFLING_LIST = 'LINES_SOUFFLING_LIST';
const LINES_SOUFFLING_SCHEMA = 'LINES_SOUFFLING_SCHEMA';
const LINES_EQUIPMENT_LIST = 'LINES_EQUIPMENT_LIST';

function getBasketItem(state: LinesSoufflingState, saved: any) {
  if (saved && saved.id) {
    return {
      id: saved.id,
      text: saved.text,
      with_button: saved.with_button,
      button_label: saved.button_label,
      field_id: saved.field_id,
      type: saved.type,
      action: saved.action,
      equipment_id: saved.equipment_id,
    };
  } else {
    return {
      id: Math.random(),
      text: null,
      with_button: null,
      button_label: null,
      field_id: null,
      type: saved.type,
      action: 'none',
      equipment_id: saved.equipment_id,
    }
  }

}

export const actions: ActionTree<LinesSoufflingState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId , type}) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.type = type;

        return new Promise((resolve, reject) => {
          const queries = [
            vm.$q(LINES_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'vls.id',
                  text: 'vls.text',
                  with_button: 'vls.with_button',
                  button_label: 'vls.button_label',
                  field_id: 'vls.field_id',
                  type: 'vls.type',
                  action: 'vls.action',
                  equipment_id: 'vls.equipment_id',
                },
                from: 's:voc_lines_souffling',
                from_as: 'vls',
                joins: [
                ],
                order: [
                  {$asc: ['vls.position']},
                  {$asc: ['vls.id']}
                ],
                page_size: 10000,
                where: {
                  $and: [
                    {$eq: [`vls.line_id`, {$: documentId}]},
                    {$eq: [`vls.type`, {$: type}]}
                  ]
                }
              }),
              vm.$q(LINES_SOUFFLING_SCHEMA)
                  .raw('schemas.get')
                  .action({
                      id: `s:voc_lines_souffling`
                  }),
            ]
            if (type == 'wash') {
              queries.push(
                vm.$q(LINES_EQUIPMENT_LIST)
                  .raw('documents.list')
                  .action({
                    columns: {
                      name: 'vv.name',
                      equipment_id: 'vle.equipment_id',
                    },
                    from: 's:voc_lines_equipments',
                    from_as: 'vle',
                    joins: [
                      {
                        join: 's:voc_volumes',
                        as: 'vv', 
                        on: {
                          '$eq': ['vle.equipment_id', 'vv.id']  
                        }
                      }
                    ],
                    page_size: 10000,
                    order: [
                      {$asc: ['vle.id']}
                    ],
                    where: {
                      $eq: [`vle.line_id`, {$: documentId}]
                    }
                  })
              )
            }

          vm.$db(queries).then((result: ServerResult) => {
            const opRelResult = result.getOperation(LINES_SOUFFLING_LIST);
            const opEqRelResult = result.getOperation(LINES_EQUIPMENT_LIST);
            if (!opRelResult.hasError()) {
              commit('SET_DATA', {
                data: opRelResult.getContent().documents.map((doc: any) => {
                  return getBasketItem(state, doc)
                }), 
                equipments: opEqRelResult ? opEqRelResult.getContent().documents : [{name: "Все", id: null}],
                schema: result.getOperation(LINES_SOUFFLING_SCHEMA).getContent().schema
              })
            }

            resolve(null);
          });
        })
    },

    addItem({ state }) {
      console.log(state.equipment)
      state.relatedSouffingList.push(
        getBasketItem(state, {type: state.type, equipment_id: state.equipment.equipment_id})
      )
    },

    removeItem({ state }, index: number) {
        if (state.relatedSouffingList[index].id) {
            state.targetForDelete.push(state.relatedSouffingList[index].id)
        }

        state.relatedSouffingList.splice(index, 1);
    },

    changeFormValue({ state }, { index, field, newValue}) {
      state.relatedSouffingList[index][field] = newValue;
    },

    saveForm({ state, dispatch }) {
      const vm = (this as any)._vm;
      const allowedFields = ['id', 'text', 'with_button', 'button_label', 'field_id', 'type', 'action', 'equipment_id'];

      return new Promise((resolve, reject) => {
        const normalizedItemsData = state.relatedSouffingList.map((item, index) => {
          const cleanDocuemnt: any = Object.keys(item)
          .filter((key: string) => allowedFields.includes(key))
          .reduce((obj: any, key: string) => {
              if (key == 'id') {
                item[key] = (typeof(item[key]) == 'string') ? item[key] : null;
              }
              obj[key] = item[key];
              return obj;
            }, {});

          console.log('d => ', cleanDocuemnt);
          return cleanDocuemnt;
        });

        const queries = [
          vm.$q(`SAVE_DEAL_BASKET`)
            .update(state.documentId, {})
            .createManyRelation('voc_lines_souffling', 'line_id', (createRelated: any) => {
              return normalizedItemsData.filter((item: any) => !item.id || (typeof(item.id) !== 'string')).map((item, index) => createRelated(item));
            })
            .updateManyRelation('voc_lines_souffling', 'line_id', (updateRelated: any) => {
              return normalizedItemsData.filter((item: any) => (typeof(item.id) == 'string')).map((item, index) => updateRelated(item))
            })
            .deleteManyRelation('voc_lines_souffling', 'line_id', (deleteRelated: any) => {
              return state.targetForDelete.map((item: any, index) => deleteRelated({ id: item }));
            })
        ]

        vm.$db(queries)
          .then((result: ServerResult) => {
            const totalSaveRes = !result.getOperation(`SAVE_DEAL_BASKET`).hasError();
            if (totalSaveRes) {
              state.targetForDelete = [];

              dispatch('loadData', { documentId: state.documentId, clientId: state.clientId, type: state.type})
                .then(() => {
                  resolve();
                })
            } else {
              reject();
            }
          });
      })
    },
    setActiveEquipment({commit}, equipment) {
      commit('SET_EQUIPMENT', equipment);
    }
};

export const mutations: MutationTree<LinesSoufflingState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  SET_DATA: (state, {data, equipments, schema}) => {
    state.relatedSouffingList = data
    state.schema = schema
    state.equipments = equipments
    state.equipment = equipments.length> 0 ? equipments[0] : null
    state.meta = fetchEnumsFromSchema(state.schema)

  },
  SET_EQUIPMENT: (state, equipment) => {
    state.equipment = equipment
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },
};

export const getters: GetterTree<LinesSoufflingState, RootState> = {
  totals : (state: LinesSoufflingState) => {
    return {
      sum: state.relatedSouffingList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
};

export const STORE_KEY = '$_lines_souffling_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
